import FutureAbsenceFilters, {FutureAbsenceFilterNames} from "root/s360components/FutureAbsence/FutureAbsenceFilters";
import FutureAbsenceManager from "root/s360components/FutureAbsence/FutureAbsenceManager";
import S360WidgetContainer from "root/s360components/LearningJournal/S360WidgetContainer";
import {useState} from "react";
import useModalFutureAbsence, {
    ModalFutureAbsenceModes
} from "root/s360components/Modals/FutureAbsence/useModalFutureAbsence";
import {getFutureAbsencesForSchool} from "root/DataFunctions/FutureAbsenceDataFns";
import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";

const FutureAbsencePage = ({school_id, class_id_filter}) =>
{

    const [filter, setFilter] = useState(FutureAbsenceFilterNames.TODAY);

    const [isValidData, setIsValidData] = useState(true);

    const [renderModalFutureAbsence, activateModalFutureAbsence] = useModalFutureAbsence();

    const [data, setData] = useState({data: [], isLoading: true});

    const getData = (filter) =>
    {
        getFutureAbsencesForSchool(school_id, filter,  (response) =>
        {
            setData({data: response.results.record_set, isLoading: false});
        })
    }

    const onClickActivateFutureAbsenceModal = (mode, longTermAbsenceID) =>
    {
        activateModalFutureAbsence({mode: mode, school_id: school_id, longTermAbsenceID: longTermAbsenceID}).then((result) =>
        {
            if (result === 'saved')
            {
                getData(filter);
            }
        })
    }

    return (
        <S360WidgetContainer style={{minHeight: '600px', margin: '20px'}}>
            <S360WidgetBlock>
                <div className='future-absence-filters'>
                    <FutureAbsenceFilters filter={filter} setFilter={setFilter}/>
                    <button type='button' className='btn btn-success btn-icon glyphicons circle_plus button-style-row'
                            onClick={() => onClickActivateFutureAbsenceModal(ModalFutureAbsenceModes.CREATE, null)}>Add
                        Absence
                    </button>
                </div>
            </S360WidgetBlock>
            <S360WidgetBlock>
                <FutureAbsenceManager school_id={school_id} filter={filter}
                                      onClickActivateFutureAbsenceModal={onClickActivateFutureAbsenceModal}
                                      getData={getData} data={data}/>
            </S360WidgetBlock>
            {renderModalFutureAbsence()}
        </S360WidgetContainer>
    )
}

export default FutureAbsencePage;